import React, { Component } from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import { branch } from 'baobab-react/higher-order'
import { Button, Image, Modal, ModalBody } from 'components/qstrap'
import ListItem from 'components/material/ListItem'
import SignIn from 'components/authentication/forms/SignIn'
import CardContainer from 'components/authentication/CardContainer'
import Footer from 'components/organisms/Footer'

class Materials extends Component {
  constructor(props) {
    super(props)

    this.state = {
      modal: false,
    }

    this.handleClick = this.handleClick.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
  }

  toggleModal() {
    this.setState({ modal: !this.state.modal })
  }

  handleClick(e) {
    const { currentUser  } = this.props

    if (!currentUser) {
      e.preventDefault()

      this.toggleModal()
    }
  }

  render() {
    const { materials } = this.props
    const { modal } = this.state

    return (
      <section id="Materials">
        <div className="material-header">
          <div className="material-line" />

          <div className="material-logo">
            <a href="/" rel="noopener" target="_blank">
              <Image src="/assets/img/logo/qc_logo_c.svg" />
            </a>
          </div>
        </div>
        <div className="material-content container">
          <div className="material-content-header material-padding m-b-md">
            <h6 className="p-b-sm">{intl.get('materials.title')}</h6>
            <div className="material-text">{intl.get('materials.description')}</div>
          </div>
          <div className="material-content-body">
            <div className="material-list">
              <div className="material-list-item material-list-item_header material-padding">
                <div className="material-list-item-left material-text-heading hidden-sm-down">
                  {intl.get('materials.month')}
                </div>
                <div className="material-list-item-middle material-text-heading">
                  {intl.get('materials.material')}
                </div>
                <div className="material-list-item-right material-text-heading hidden-sm-down">
                  {intl.get('materials.option')}
                </div>
              </div>
              {
                materials &&
                materials.map(material => (
                  <ListItem
                    key={material.id}
                    handleClick={this.handleClick}
                    {...material}
                  />
                ))
              }
            </div>
          </div>
          <div className="material-content-footer">
            <div className="material-sign-in">
              <Button tag="a" href="/" target="_blank" rel="noopener" color="campus">
                {intl.get('materials.join_quipper_campus')}
              </Button>
            </div>
          </div>
        </div>
        <div className="material-footer">
          <Footer />
        </div>

        <Modal autoFocus={false} isOpen={modal} fade={false} className="get-more-info-modal" toggle={this.toggleModal}>
          <ModalBody>
            <CardContainer>
              <div className="external-container text-center container">
                <SignIn successUrl="/materials" />
              </div>
            </CardContainer>
          </ModalBody>
        </Modal>
      </section>
    )
  }
}

Materials.propTypes = {
  currentUser: PropTypes.object,
  materials: PropTypes.array,
}

export { Materials }
export default branch({
  currentUser: ['serverProps', 'currentUser'],
  materials: ['serverProps', 'materials'],
}, Materials)
